import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateNavbarHeading } from '../../../constants/layout/store/filterSlice';
import { GetServiceCaller,PostFormServiceCaller } from '../../../services/serviceCaller';
import { API_URL } from '../../../constants';
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomDatePicker from "../../../components/Custom-Datepicker";
import Dynamic_PR_table from '../../../components/Dynamic_PR_table';

const RequisitionResourceListing = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [apiStatus, SetApiStatus] = useState(undefined);
  const [searchTerm, setSearchTerm] = useState("");
  const [projectListdata, setProjectListData] = useState([]);
  
  // Available pool configuration states populated from details response
  const [employeeDropdownOptions, setEmployeeDropdownOptions] = useState([]);
  const [bandDropdownOptions, setBandDropdownOptions] = useState([]);
  
  const [errors, setErrors] = useState({});
  const [selectedRecord, setSelectedRecord] = useState(null);

  // Modal Control States
  const [showFormModal1, setShowFormModal1] = useState(false);       
  const [showConfirmModal2, setShowConfirmModal2] = useState(false); 
  const [showConfirmModal3, setShowConfirmModal3] = useState(false); 

  // Single Source tracking structure for our dynamic state updates
  const [formData, setFormData] = useState({
    employeeList: [],   // Managed by react-select
    band: "",           // Holds Target BandID value
    minBudget: "",      // Changed from inputField to map to MinBudget
    maxBudget: "",      // New field added for MaxBudget
    RequirementDate: "" // Maps directly to JobStatsChangeDate
  });

  const customStyle = {
    control: (provided) => ({
      ...provided,
      border: "2px solid #dee2e6",
      backgroundColor: "#f8f9fa",
      borderRadius: "0.375rem",
      boxShadow: "none",
      "&:hover": { borderColor: "#ced4da" },
      minHeight: "38px"
    })
  };

  useEffect(() => {
    dispatch(updateNavbarHeading("Requisition Resource"));
    fetchProjectListingData();
  }, []);

  const columns = {
    JobCode: { text: "JobCode", align: "start", visible: true },
    JobtileName: { text: "JobTile Name", align: "start", visible: true },
    Role: { text: "Role", align: "start", visible: true },
    RequirementDate: { text: "Req.Date", align: "start", visible: true },
    OpeningType: { text: "Opening Type", align: "start", visible: true },
    NumOpenings: { text: "Num.Openings", align: "start", visible: true },
    MinExp: { text: "Min. Exp", align: "start", visible: true },
    MaxExp: { text: "Max. Exp", align: "center", visible: true },
    skills: { text: "Skills", align: "center", visible: true },
    SubSkills: { text: "Sub Skills", align: "center", visible: true },
  };

  const fetchProjectListingData = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}requisition-resource`);
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const fetchData = response?.data?.data?.data;
        setProjectListData(fetchData);
      } else {
        console.error("Failed to fetch project listings.", response);
      }
    } catch (error) {
      console.error("Fetching API Error", error);
    }
  };

  // --- SINGLE SOURCE OF TRUTH RESPONSE PARSING ACTIONS ---
  const handleIcon1Click = async (record) => {
    // Save the incoming selected record to access its unique ID later (e.g., record.id or record.Id)
    setSelectedRecord(record || null);
    
    // Hard reset fields immediately prior to calling resource server
    setFormData({
      employeeList: [],
      band: "",
      minBudget: record?.MinBudget || record?.Budget || "", 
      maxBudget: record?.MaxBudget || "",
      RequirementDate: record?.RequirementDate || ""
    });
    setEmployeeDropdownOptions([]);
    setBandDropdownOptions([]);

    try {
      const response = await GetServiceCaller(`${API_URL}get-ta-requisition-resource-details`);
      
      if (response?.status === 200) {
        const detailData = response?.data?.data || response?.data;
        
        if (detailData) {
          // 1. Map Employee Array elements directly for react-select usage
          const rawEmployees = Array.isArray(detailData.employeelist) ? detailData.employeelist : [];
          const formattedEmployees = rawEmployees.map((emp) => ({
            value: emp.value,
            label: emp.text 
          }));
          setEmployeeDropdownOptions(formattedEmployees);

          // 2. Map Band Array elements safely to prevent DOM node structural child crashes
          const rawBands = Array.isArray(detailData.band) ? detailData.band : [];
          const formattedBands = rawBands.map((b) => ({
            value: b.value,
            text: b.text || b.value
          }));
          setBandDropdownOptions(formattedBands);

          // 3. Consolidate into React rendering pipeline (Initializing employeeList empty)
          setFormData({
            employeeList: [], 
            band: detailData.selectedBand || record?.band || record?.Band || "", 
            minBudget: detailData.minBudget || detailData.budget || record?.MinBudget || record?.Budget || "",
            maxBudget: detailData.maxBudget || record?.MaxBudget || "",
            RequirementDate: detailData.RequirementDate || record?.RequirementDate || ""
          });
        }
      } 
    } catch (error) {
      console.error("Error communicating with yet-requisition-resource-details endpoint", error);
    }

    // Modal view visibility triggered successfully inside functional block frame
    setShowFormModal1(true);
  };

  const handleAddNewCreateProject = () => {
    navigate(`/add-requisition-resource`);
  };

  const handleIcon2Click = (record) => {
    setSelectedRecord(record || null);
    setShowConfirmModal2(true);
  };

  const handleIcon3Click = (record) => {
    setSelectedRecord(record || null);
    setShowConfirmModal3(true);
  };

  const handleConfirmAction2 = () => {
    setShowConfirmModal2(false);
  };

  const handleConfirmAction3 = () => {
    setShowConfirmModal3(false);
  };

  const handleReactSelectChange = (selectedOptions) => {
    setFormData((prev) => ({ 
      ...prev, 
      employeeList: selectedOptions || [] 
    }));
  };

  const handleFormInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCustomDateChange = (dateValue) => {
    if (dateValue instanceof Date && !isNaN(dateValue)) {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const day = String(dateValue.getDate()).padStart(2, '0');
      const month = months[dateValue.getMonth()];
      const year = dateValue.getFullYear();
      
      const formattedString = `${day}-${month}-${year}`;

      setFormData((prev) => ({ 
        ...prev, 
        RequirementDate: formattedString 
      }));
    } 
    else if (typeof dateValue === "string") {
      setFormData((prev) => ({ 
        ...prev, 
        RequirementDate: dateValue 
      }));
    }
    else if (dateValue && dateValue.target) {
      setFormData((prev) => ({ 
        ...prev, 
        RequirementDate: dateValue.target.value 
      }));
    }
  };

  // --- SUBMIT HANDLING WITH INTEGRATED PUT METHOD ---
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    const recordId = selectedRecord?.ID;
    const interviewPanelsCSV = formData.employeeList.map(opt => opt.value).join(",");
    
    const payload = {
      JobStatsChangeDate: formData.RequirementDate,
      BandID: formData.band,
      MinBudget: formData.minBudget,
      MaxBudget: formData.maxBudget,
      InterviewPannels: interviewPanelsCSV
    };
    
    try {
      const response = await PostFormServiceCaller(
        `${API_URL}requisition-resource/${recordId}`,
        payload,
        "put"
      );
      
      if (response?.status === 200 || response?.status === 204) {
        toast.success("Data has been submitted successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        
        setShowFormModal1(false);
        fetchProjectListingData();
      } else {
        toast.error("Failed to update data. Please try again.");
        console.error("Failed server synchronization:", response);
      }
    } catch (error) {
      toast.error("An error occurred during submission pipeline.");
      console.error("Critical submission routing error:", error);
    }
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <div className="row">
          <Dynamic_PR_table
            data={projectListdata}
            columns={columns}
            itemsPerPage={8}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            showIcon1={true}
            showIcon2={true}
            showIcon3={true}
            showIcon4={false}
            showIcon5={false}
            isApiStatus={apiStatus}
            isRequiredStatus={true}
            isActionRequired={true}
            isAddNewBtnRequired={true}
            
            handleIcon1={(rec) => handleIcon1Click(rec)}
            handleIcon2={(rec) => handleIcon2Click(rec)}
            handleAmendmentLog={(rec) => handleIcon2Click(rec)} 
            handleIcon3={(rec) => handleIcon3Click(rec)}
            
            handleAddNew={handleAddNewCreateProject}
            icons={{
              Icon1: <i className="bi bi-person-check text-success fs-5"></i>,
              Icon1Text: "TA Request", 
              Icon2: <i className="bi bi-people text-success fs-5"></i>,
              Icon2Text: "RMG Request",
              Icon3: <i className="bi bi-pause-circle text-warning fs-5" ></i>,
              Icon3Text: "Hold",
            }}
          />
        </div>
      </div>

      {/* ==================== FORM MODAL 1 (TA REQUEST) ==================== */}
      {showFormModal1 && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div className="modal-content shadow-lg border-0 rounded-3">
              
              <div className="modal-header bg-light border-bottom-0 py-3 px-4">
                <h5 className="modal-title fw-bold text-dark">
                  <i className="bi bi-sliders me-2 text-success"></i> Talent Resource Requisition Request
                </h5>
                <button type="button" className="btn-close shadow-none" onClick={() => setShowFormModal1(false)}></button>
              </div>

              <form onSubmit={handleFormSubmit}>
                <div className="modal-body p-4">
                  {/* Changed row mapping columns grid classes to col-xl-2.5 or adjusted widths to fit 5 items cleanly */}
                  <div className="row g-3 align-items-end">
                    
                    {/* Field 1: Dynamic Multi-Select dropdown for Interview Panels */}
                    <div className="col-xl-3 col-md-6">
                      <label className="form-label fw-semibold text-secondary">Interview Panels</label>
                      <Select
                        menuShouldScrollIntoView={true}
                        isMulti
                        styles={customStyle}
                        name="employeeList"
                        className={`basic-multi-select ${errors?.employeeList ? "is-invalid" : ""}`}
                        classNamePrefix="select"
                        value={formData.employeeList}
                        onChange={handleReactSelectChange}
                        options={employeeDropdownOptions}
                        placeholder="Select panels..."
                        required
                      />
                    </div>

                    {/* Field 2: Dynamically Populated Band Options Selector */}
                    <div className="col-xl-2 col-md-6">
                      <label className="form-label fw-semibold text-secondary">Band</label>
                      <select 
                        className="form-select border-2 bg-light shadow-none" 
                        name="band" 
                        value={formData.band}
                        onChange={handleFormInputChange}
                        required
                        style={{ height: "38px" }}
                      >
                        <option value="">Select band...</option>
                        {bandDropdownOptions.map((bandOption, index) => (
                          <option key={index} value={bandOption.value}>
                            {bandOption.text}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Field 3: Integrated CustomDatePicker Element */}
                    <div className="col-xl-3 col-md-6">
                      <label className="form-label fw-semibold text-secondary">Job Status Change Date</label>
                      <CustomDatePicker
                        handleChange={handleCustomDateChange}
                        value={formData.RequirementDate}
                        name="RequirementDate"
                        className={`form-control border-2 bg-light shadow-none ${
                          errors?.RequirementDate ? "is-invalid" : ""
                        }`}
                        placeholderText="DD-MMM-YYYY"
                      />
                    </div>

                    {/* Field 4: Min Budget Text Input Field */}
                    <div className="col-xl-2 col-md-6">
                      <label className="form-label fw-semibold text-secondary">Min Budget</label>
                      <input 
                        type="text" 
                        className="form-control border-2 bg-light shadow-none" 
                        placeholder="Min Amount"
                        name="minBudget"
                        value={formData.minBudget}
                        onChange={handleFormInputChange}
                        required
                        style={{ height: "38px" }}
                      />
                    </div>

                    {/* Field 5: Max Budget Text Input Field */}
                    <div className="col-xl-2 col-md-6">
                      <label className="form-label fw-semibold text-secondary">Max Budget</label>
                      <input 
                        type="text" 
                        className="form-control border-2 bg-light shadow-none" 
                        placeholder="Max Amount"
                        name="maxBudget"
                        value={formData.maxBudget}
                        onChange={handleFormInputChange}
                        required
                        style={{ height: "38px" }}
                      />
                    </div>

                  </div>
                </div>

                <div className="modal-footer border-top-0 bg-light p-3 px-4">
                  <button type="button" className="btn btn-outline-secondary px-4 rounded-pill fw-medium" onClick={() => setShowFormModal1(false)}>Cancel</button>
                  <button type="submit" className="btn btn-success px-4 rounded-pill fw-medium text-white">Save Changes</button>
                </div>
              </form>

            </div>
          </div>
        </div>
      )}

      {/* ==================== CONFIRMATION MODAL 2 (RMG REQUEST) ==================== */}
      {showConfirmModal2 && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content shadow border-0 rounded-3">
              <div className="modal-header border-bottom-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-info d-flex align-items-center">
                  <i className="bi bi-people me-2"></i> Confirm RMG Request
                </h5>
                <button type="button" className="btn-close shadow-none" onClick={() => setShowConfirmModal2(false)}></button>
              </div>
              <div className="modal-body px-4 py-2">
                <p className="text-muted">Are you sure you want to dispatch this file entry to the Resource Management Group (RMG)?</p>
              </div>
              <div className="modal-footer border-top-0 pb-4 px-4 justify-content-end">
                <button type="button" className="btn btn-outline-secondary rounded-pill px-4 me-2" onClick={() => setShowConfirmModal2(false)}>Cancel</button>
                <button type="button" className="btn btn-info rounded-pill px-4 text-white" onClick={handleConfirmAction2}>Confirm RMG</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ==================== CONFIRMATION MODAL 3 (HOLD) ==================== */}
      {showConfirmModal3 && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content shadow border-0 rounded-3">
              <div className="modal-header border-bottom-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-warning d-flex align-items-center">
                  <i className="bi bi-pause-circle-fill me-2"></i> Place On Standby Hold
                </h5>
                <button type="button" className="btn-close shadow-none" onClick={() => setShowConfirmModal3(false)}></button>
              </div>
              <div className="modal-body px-4 py-2">
                <p className="text-muted">This action freezes updates on the requisition request profile. Proceed to put this record on hold?</p>
              </div>
              <div className="modal-footer border-top-0 pb-4 px-4 justify-content-end">
                <button type="button" className="btn btn-outline-secondary rounded-pill px-4 me-2" onClick={() => setShowConfirmModal3(false)}>Cancel</button>
                <button type="button" className="btn btn-warning rounded-pill px-4 text-white" onClick={handleConfirmAction3}>Confirm Hold</button>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};
export default RequisitionResourceListing